export default "__VITE_ASSET__B64WAac3__"